import React from 'react';
import List from '../../rest/List';
import RestFieldItem from '../../../components/RestField/RestFieldItem';
import ActionGroup from '../../../components/RestActions/ActionGroup';
import EditButton from '../../../components/RestActions/EditButton';
import DeleteButton from '../../../components/RestActions/DeleteButton';

const OrderRequirementsList = props => (
  <List {...props} resource="orderRequirements">
    <RestFieldItem source="name" header="orderRequirements.name" />
    <RestFieldItem source="description" header="orderRequirements.description" />
    <ActionGroup>
      <EditButton />
      <DeleteButton />
    </ActionGroup>
  </List>
);

OrderRequirementsList.propTypes = {};

export default OrderRequirementsList;
